import React from "react";
import { Link } from "react-router-dom";

/**
 * Slug città (es. "Reggio Emilia" -> "reggio-emilia").
 * Usato per costruire il link a /migliori/[slug] (pagina hub città).
 */
function citySlug(city) {
  if (!city) return "";
  return city
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/'/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

/**
 * Etichetta tipo scuola (pubblica / paritaria / privata) — case sensitive DB.
 */
function typeLabel(type) {
  const t = (type || "").toLowerCase();
  if (t === "pubblica") return "pubblica";
  if (t === "paritaria") return "paritaria";
  if (t === "privata") return "privata";
  return "paritaria o privata";
}

/**
 * Paragrafo SEO auto-generato per ogni pagina scuola.
 * Sostituisce il vecchio `school.description` MIUR ("thin content")
 * con un blocco ~90-110 parole ottimizzato per ricerche locali.
 *
 * Usa dati già presenti nel DB: name, type, city, province, postal_code.
 * Zero migrazione, aggiornabile globalmente cambiando questo componente.
 */
export function SchoolSeoParagraph({ school }) {
  if (!school) return null;
  const slug = citySlug(school.city);
  const tLabel = typeLabel(school.type);

  return (
    <div
      data-testid="school-seo-paragraph"
      className="mt-6 font-ui text-sm text-[#5C6B64] leading-relaxed space-y-3"
    >
      <p>
        <strong className="text-[#1A362D]">"{school.name}"</strong> si trova nel
        comune di <strong>{school.city}</strong> ({school.province})
        {school.postal_code ? `, CAP ${school.postal_code}` : ""}. È una scuola
        dell'infanzia <strong>{tLabel}</strong> che accoglie bambine e bambini
        dai 3 ai 6 anni.
      </p>
      <p>
        Su Per manina i genitori possono leggere esperienze oneste lasciate da
        altre famiglie che frequentano o hanno frequentato questa scuola, per
        orientarsi meglio nella scelta della scuola dell'infanzia. Se sei un
        genitore e conosci <strong>{school.name}</strong>, la tua opinione può
        aiutare altre famiglie del quartiere: scorri più in basso e lascia la
        tua esperienza sincera.
      </p>
      {slug && (
        <p>
          Non trovi la scuola giusta? Consulta l'elenco delle{" "}
          <Link
            to={`/migliori/${slug}`}
            data-testid="school-seo-city-link"
            className="text-[#C05C45] underline hover:text-[#1A362D]"
          >
            scuole dell'infanzia a {school.city}
          </Link>{" "}
          per orientarti tra le opzioni della tua zona.
        </p>
      )}
    </div>
  );
}
